import { mergeStyleSets } from "@fluentui/react";
import styled from "styled-components";

export const modalStyles = mergeStyleSets({
  container: {
    display: 'flex',
    borderRadius: 16,
    width: 650,
    padding: '32px 16px',
    boxShadow: 'inset 0 6px 0 0 #FD6262, 1px 1px 8px rgba(0, 0, 0, 0.05)'
  },
});

export const DownloadModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* min-height: 500px; */
`;

export const DownloadModalHeader = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  padding: 0 20px 20px; 
  align-items: center;

  h1 {
    font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
    white-space: nowrap;
  }
  
  h2 {
    border-left: 1px solid #dfdfdf;
    padding-left: 12px;
    font: 400 0.9rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }

  .closeModal {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
`;

export const DownloadModalFooter = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
`

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span {
    font: 700 0.7rem/1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.themeDark};
  }

  input {
    padding: 0 1rem;
    font: 300 0.8rem/1rem 'Roboto', sans-serif;
    height: 100%;
    border: 1px solid hsl(0, 0%, 80%);
    border-radius: 5px;
    
    &::placeholder {
      color: hsl(0, 0%, 60%);
    }
  }

  select {
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    font: 300 0.8rem/1.1rem 'Roboto',sans-serif;

    &:focus {
      border: 1px solid ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }
`;